import React, { useEffect, useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { axiosSetting } from '../../libs/utils'
import { useForm } from 'react-hook-form'
import FormController from './FormController'
import SelectInput from './SelectInput'
import MobileNumberInput from './MobileNumberInput'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import QutestionMark from '../../assets/svg/QutestionMark'
import { useAppContext } from '../../libs/contextLib'


const AskQuestionButton = ({ salesData, config }) => {
  const [isLoading, setisLoading] = useState(false)
  const { configureData } = useAppContext()
  const axiosConsumer = axiosSetting('G4mZ5788YqDOwHdSnN')
  const [show, setShow] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm()

  useEffect(() => {
    if (show) {
      reset({
        firstName: salesData?.data?.fname,
        lastName: salesData?.data?.lname,
        how_can_help: '',
        email: salesData?.data?.email,
        phone: '',
        subject: '',
        description: '',
      })
    }
    return () => { }
  }, [reset, salesData, show])

  const handleClose = () => setShow(false)

  const onSubmit = async (values) => {
    setisLoading(true)
    try {
      const { status } = await axiosConsumer.post('/ask-question-desk', {
        message: `<div style="background-color: rgba(243, 248, 254, 0.4); padding: 0.5rem; border-radius: 0.5rem; overflow: hidden;"> <table style="width: 100%; border-collapse: collapse;"> <tr> <td style="color: #000; font-weight: 500; padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">First Name</td> <td style="padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">${values.firstName}</td> </tr> <tr> <td style="color: #000; font-weight: 500; padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">Last Name</td> <td style="padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">${values.lastName}</td> </tr> <tr> <td style="color: #000; font-weight: 500; padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">How can we help you?</td> <td style="padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">${values.how_can_help}</td> </tr> <tr> <td style="color: #000; font-weight: 500; padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">Email</td> <td style="padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">${values.email}</td> </tr> <tr> <td style="color: #000; font-weight: 500; padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">Phone</td> <td style="padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">${values.phone}</td> </tr> <tr> <td style="color: #000; font-weight: 500; padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">Subject</td> <td style="padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">${values.subject}</td> </tr> <tr> <td style="color: #000; font-weight: 500; padding: 0.5rem;">Description</td> <td style="padding: 0.5rem;">${values.description}</td> </tr> </table> </div>
    `,
        email: values?.email,
        phone: values?.phone,
      })
      if (status === 200) {
        toast.success(
          'Thank you for submitting your query. We will contact you shortly.'
        )
        handleClose()
      } else {
        toast.error(
          'Oops! Something went wrong. Your response was not saved. Please try again.'
        )
      }
    } catch (error) {
      toast.error(
        error?.message ||
        'Oops! Something went wrong. Your response was not saved. Please try again.'
      )
    } finally {
      setisLoading(false)
    }
  }

  return (
    <>
      <div className="askButtonWrapper">
        <button
          style={{
            background: config?.color,
            borderColor: config?.color,
            color: config?.textColor
          }}
          className="btn shadow-none rounded-pill"
          onClick={() => setShow(true)}
        >
          <QutestionMark height={24} width={24} />
          <span className="ml-2 font-font-weight-light">
            Ask a Question
          </span>
        </button>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        animation
        className={`${configureData.name}-modal` || 'protectall-modal'}
      >
        <Form noValidate onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header
            style={{ textAlign: 'center', alignItems: 'center' }}
            closeButton
          >
            <Modal.Title>Ask a Question</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 gap-2 d-flex flex-column" style={{ gap: 8 }}>
              <FormController
                type="text"
                label="First Name"
                placeholder="John"
                errors={errors}
                {...register('firstName', {
                  required: 'Please enter a valid first name',
                })}
              />

              <FormController
                type="text"
                label="Last Name"
                placeholder="Doe"
                errors={errors}
                {...register('lastName', {
                  required: 'Please enter a valid last name',
                })}
              />

              <SelectInput
                placeholder={'How can we help you?'}
                label="How can we help you?"
                errors={errors}
                options={[
                  'Need assistance completing transaction',
                  'Questions about coverage',
                  'My info shown is incorrect',
                  'Other',
                ]}
                {...register('how_can_help', {
                  required: 'Please select one reason',
                  value: '',
                })}
              />

              <FormController
                type="email"
                label="Email"
                placeholder="example@email.com"
                errors={errors}
                {...register('email', {
                  required: 'Please enter a valid email',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Please enter a valid email',
                  },
                })}
              />

              <MobileNumberInput
                type="text"
                label="Phone"
                placeholder="(987) 456 3210"
                errors={errors}
                format="(###) ### ####"
                mask="_"
                {...register('phone', {
                  validate: (val) => {
                    const phoneNumber = parsePhoneNumberFromString(val, 'US')
                    return phoneNumber?.isValid() || 'Please enter a valid phone number'
                  },
                })}
              />

              <FormController
                type="text"
                label="Subject"
                placeholder="Enter subject"
                errors={errors}
                {...register('subject', {
                  required: 'Please enter a valid subject',
                })}
              />

              <FormController
                type="textarea"
                label="Description"
                placeholder="Enter Description"
                errors={errors}
                {...register('description', {
                  required: 'Please enter a valid description',
                })}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary shadow-none"
              onClick={handleClose}
              type="button"
            >
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary shadow-none d-flex align-items-center"
              onClick={handleSubmit}
              disabled={isLoading}
              style={{
                opacity: isLoading && 0.6,
                cursor: isLoading && 'not-allowed',
              }}
            >
              {isLoading && <span class="loader mr-1" />}
              Submit
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export default AskQuestionButton
